<template>
    <div class="PageError u-frameMd">
        <h1><span>404</span> stránka nenalezena</h1>
    </div>
</template>

<style lang="scss" scoped>
.PageError {
    padding-top: 40px;
    padding-bottom: 40px;

    h1 {
        text-align: center;
        line-height: 1.1;

        span {
            display: block;
            font-size: 3em;
        }
    }
}
</style>